import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import AddBookSummaryPopup from "./addSummaryPopup";

const AddSummaryPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // Back to the list as it was left, filters included (they live in its URL).
  const goBack = () => navigate(location.state?.returnTo || "/summary");

  return (
    <AddBookSummaryPopup
      isModalVisible={true}
      isPageView={true}
      closeModal={goBack}
      onSuccess={goBack}
    />
  );
};

export default AddSummaryPage;
